import { useState } from 'react';
import { faqs } from '@/mocks/site';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <span className="text-xs font-medium tracking-[0.2em] text-accent-700">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于信源、核实、反转与第二弹，我们被问得最多的几个问题都在这里。看完了还有疑问，可以直接在底部投稿区留言。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-question-answer-line" />
              还有问题要问
            </a>
          </div>

          <div className="lg:col-span-2">
            <div className="flex flex-col gap-3">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={item.q}
                    className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                      isOpen ? 'border-primary-300' : 'border-background-200'
                    }`}
                  >
                    <h3>
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                      >
                        <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                          {item.q}
                        </span>
                        <span
                          className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                          }`}
                        >
                          <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="border-t border-background-100 px-5 py-4">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}